export default __webpack_public_path__ + "static/media/Epicor.06d7b183.png";